/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Plh_TitleInputs */

const vi_sl_plh_title = /** @type {(inputs: Sl_Plh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu lấy hàng`)
};

/**

* @param {Sl_Plh_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_plh_title = /** @type {((inputs?: Sl_Plh_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Plh_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_plh_title(inputs)
});